
const graficoItens = (itemsFolhas) =>  {
  let groupItem = [];
  let itemAux = [];
  itemsFolhas.forEach((el) => {
    if(!itemAux.includes(el.sq_categoria_item_folha)){
      itemAux.push(el.sq_categoria_item_folha);
      groupItem[el.sq_categoria_item_folha] = el;
      groupItem[el.sq_categoria_item_folha].soma = 0;
      groupItem[el.sq_categoria_item_folha].descricao = el.ds_categoria_item_folha;
    }
    groupItem[el.sq_categoria_item_folha].soma += parseFloat(el.vl_lcto);
  });
  let seriesAux = [];
  let labelAux = [];
  let colorsAux = [];
  groupItem = groupItem.sort((a,b) => {return b.soma - a.soma})
  groupItem.forEach((el) => {
    seriesAux.push(el.soma);
    labelAux.push(el.descricao);
    colorsAux.push(el.ds_cor_fatia_grafico_web);
  })
  return {
    series: seriesAux,   
    chartOptions: {
      labels: labelAux,
      colors: colorsAux,
      customScale: 0.5,
      legend: {
        show: false,
      },
      tooltip: {
        y: { 
          formatter: function (val) {
            return parseFloat(val).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
          },
        }
      },
    }
  };
}

const graficoItensLabel = (itemsFolhas) =>  {
  let groupItem = [];
  let itemAux = [];
  itemsFolhas.forEach((el) => {
    if(!itemAux.includes(el.sq_categoria_item_folha)){
      itemAux.push(el.sq_categoria_item_folha);
      groupItem[el.sq_categoria_item_folha] = el;
      groupItem[el.sq_categoria_item_folha].soma = 0;
      groupItem[el.sq_categoria_item_folha].descricao = el.ds_categoria_item_folha;
    }
    groupItem[el.sq_categoria_item_folha].soma += parseFloat(el.vl_lcto);
  });
  let seriesAux = [];
  let labelAux = [];
  let colorsAux = [];
  groupItem = groupItem.sort((a,b) => {return b.soma - a.soma})
  groupItem.forEach((el) => {
    seriesAux.push(el.soma);
    labelAux.push(el.descricao);
    colorsAux.push(el.ds_cor_fatia_grafico_web);
  })
  return {
    series: seriesAux,   
    chartOptions: {
      labels: labelAux,
      colors: colorsAux,
      customScale: 0.5,
      legend: {
        position: 'right',
      },
      tooltip: {
        y: { 
          formatter: function (val) {
            return parseFloat(val).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
          },
        }
      },
    }
  };
}

const graficoCategorias = (categorias, sqCategoria) => {
  let arrayCategorias = categorias.filter((el) => el.sq_categoria_item_folha == parseInt(sqCategoria));
  let labelAux = [];
  let seriesAux = [];
  arrayCategorias.forEach((el) => {
    if(!labelAux.includes(el.ds_item)){
      let index = labelAux.push(el.ds_item);
      seriesAux[index - 1] = parseFloat(el.vl_lcto);
    }else{
      let index = labelAux.indexOf(el.ds_item);
      seriesAux[index] += parseFloat(el.vl_lcto);
    }
  });
  if(arrayCategorias.length == 0){
    return false
  }
  return {
   nameChart:arrayCategorias[0].ds_categoria_item_folha,
    series: [{
        data: seriesAux
    }],
    chartOptions: {
      chart: {
        toolbar: {
          show: false,
        }
      },
      plotOptions: {
        bar: {
          barHeight: '75%',
          distributed: true,
          horizontal: true,
          dataLabels: {
            position: 'bottom'
          },
        }
      },
      
      colors: ['#556ee6', '#34c38f', '#50a5f1', '#f1b44c', '#f1b44c', '#f46a6a', '#343a40', '#74788d',],
      dataLabels: {
        enabled: true,
        textAnchor: 'start',
        formatter: function (val, opt) {
          return opt.w.globals.labels[opt.dataPointIndex] + ":  " + parseFloat(val).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
        },
      },

      xaxis: {
        categories: labelAux,
        colors: '#74788d',
        labels: {
          show: false
        }
      },
      yaxis: {
        labels: {
          show: false
        }
      },
      tooltip: {
        theme: 'dark',
        x: {
          show: true
        },
        y: {
          title: {
            formatter: function () {
              return ''
            }
          },
          formatter: function (val) {
            return parseFloat(val).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
          },
        }
      },
      legend: {
        show: false,
      }
    }
  }  
};



export { graficoItens, graficoItensLabel, graficoCategorias};